import React from 'react';
import { motion } from 'framer-motion';
import { Facebook, Instagram } from 'lucide-react';
export function SocialSection() {
  return <section className="py-20 px-5 md:px-[5%] bg-fondo-crema" data-id="element-69">
      <div className="max-w-5xl mx-auto text-center" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-71">
          <h2 className="text-verde-oscuro text-3xl md:text-[2.8rem] font-serif mb-5" data-id="element-72">
            Seguinos en redes
          </h2>
          <p className="text-lg font-sans text-texto max-w-2xl mx-auto mb-10" data-id="element-73">
            Conocé el día a día de nuestra residencia, novedades y momentos
            especiales junto a nuestra comunidad.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-wrap gap-5 justify-center" data-id="element-74">
          <a href="https://www.facebook.com/profile.php?id=61589705480181" target="_blank" rel="noopener noreferrer" aria-label="Visitar nuestro Facebook" className="group flex items-center gap-3 bg-[#1877F2] text-white py-4 px-8 rounded-md no-underline font-bold font-sans transition-all hover:bg-[#0d65d9] hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#1877F2]/40 shadow-md" data-id="element-75">
            <Facebook size={24} className="transition-transform group-hover:scale-110" data-id="element-76" />
            <span data-id="element-77">FACEBOOK</span>
          </a>

          <a href="https://www.instagram.com/vinculos_devida?igsh=MWMzMjAwNXNyMjc1Mg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Visitar nuestro Instagram" className="group flex items-center gap-3 text-white py-4 px-8 rounded-md no-underline font-bold font-sans transition-all hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-pink-400/40 shadow-md" style={{
          background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)'
        }} data-id="element-78">
            <Instagram size={24} className="transition-transform group-hover:scale-110" data-id="element-79" />
            <span data-id="element-80">INSTAGRAM</span>
          </a>
        </motion.div>
      </div>
    </section>;
}